export default __webpack_public_path__ + "static/combined-cc119d195b4742c2588ba4674b19695b.mp4";